/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowDebtorDocumentsQueryResponse, GetShowDebtorDocumentsPathParams, GetShowDebtorDocumentsQueryParams, GetShowDebtorDocuments400, GetShowDebtorDocuments401 } from "../../models/GetShowDebtorDocuments";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowDebtorDocumentsUrl({ debtorCode }: { debtorCode: GetShowDebtorDocumentsPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/documents` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/documents}
 */
export async function getShowDebtorDocuments({ debtorCode, params }: { debtorCode: GetShowDebtorDocumentsPathParams["debtorCode"]; params: GetShowDebtorDocumentsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowDebtorDocumentsQueryResponse, ResponseErrorConfig<GetShowDebtorDocuments400 | GetShowDebtorDocuments401>, unknown>({ method : "GET", url : getGetShowDebtorDocumentsUrl({ debtorCode }).url.toString(), params, ... requestConfig })  
  return res.data
}